import { render, staticRenderFns } from "./HomeBox.vue?vue&type=template&id=e8028d72&"
import script from "./HomeBox.vue?vue&type=script&lang=ts&"
export * from "./HomeBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports